import { Box, Button, Card, CardContent, Stack } from '@mui/material'
import { CustomDatePicker } from '@planning/components/CustomDatePicker'
import { VesselVisitAutoComplete } from '@planning/components/visit/VesselVisitAutoComplete'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { ContainerJourneyReportViewStore } from '../../stores/ContainerJourneyReportViewStore'

interface ContainerJourneyReportTableFiltersProps {
  store: ContainerJourneyReportViewStore
}

export const ContainerJourneyReportTableFilters = observer(
  ({ store }: ContainerJourneyReportTableFiltersProps) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    const handleSearchClick = async () => {
      await store.fetch()
    }

    return (
      <Card>
        <CardContent
          sx={{
            padding: theme.customSpacing.m,
            '&:last-child': { paddingBottom: 0 },
            '& .MuiFormControl-root': { margin: 0 },
          }}
        >
          <Stack
            direction={{ md: 'row' }}
            spacing={2}
            alignItems={{ xs: 'stretch', md: 'flex-start' }}
          >
            <Box sx={{ width: 200 }}>
              <CustomDatePicker
                id='date-from'
                label={t('periodFrom', 'From')}
                value={store.from ? dayjs(store.from) : null}
                onChange={val => {
                  if (val) store.setFrom(val.toDate())
                }}
                error={false}
                helperText={undefined}
                disableFuture
                required
              />
            </Box>

            <Box sx={{ width: 200 }}>
              <CustomDatePicker
                id='date-to'
                label={t('periodTo', 'To')}
                value={store.to ? dayjs(store.to) : null}
                onChange={val => {
                  if (val) store.setTo(val.toDate())
                }}
                error={false}
                helperText={undefined}
                disableFuture
                required
              />
            </Box>

            <Box sx={{ minWidth: 400 }}>
              <VesselVisitAutoComplete
                cargoType='Container'
                displayPopupIcon
                enablePortal
                label={t('vesselVisit', 'Vessel Visit')}
                handleOnChange={async entity => {
                  store.setVesselVisitId(entity ? Number(entity.id) : undefined)
                }}
              />
            </Box>

            <Box sx={{ width: 80 }}>
              <Button
                variant='contained'
                color='primary'
                fullWidth
                size='large'
                onClick={handleSearchClick}
                sx={{ height: 56 }}
                disabled={!store.from || !store.to}
              >
                {t('search', 'Search')}
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    )
  },
)
